(ns frontend.view.modals.dynamic.events
  (:require [clojure.string :as string]))

(defn form-not-ready? [state]
  (string/blank? (:value @state)))

(defn reset-state! [state]
  (reset! state {}))
